module.exports = __webpack_public_path__ + "img/close-blue.26fe37d1.svg";